import API from "src/Helpers/API";
import UserEntryDataService from "src/Helpers/UserEntryDataService";

export const saveUserEntryData = (data) => {
  new UserEntryDataService(new API()).saveEntryData(data);
};
